export default "__VITE_ASSET__7e4f9efc__"